var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfExclusionFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12a6 6 0 110 12 6 6 0 010-12zm3.53 2.47a.75.75 0 00-1.004-.052l-.056.052-6 6-.052.056a.75.75 0 001.056 1.056l.056-.052 6-6 .052-.056a.75.75 0 00-.052-1.004zm-9.318-1.341A7.469 7.469 0 0010.413 18c0 1.067.224 2.081.625 3H3.912c-.552 0-.99-.448-.9-.993C3.36 17.89 4.93 13.125 12 13.125c.071 0 .142.003.212.004zM12 3c2.51 0 4.544 2.015 4.544 4.5S14.51 12 12 12 7.456 9.985 7.456 7.5 9.49 3 12 3z",
    fill: "currentColor"
  })));
}
SvgSelfExclusionFilled.displayName = 'SelfExclusionFilled';
export default SvgSelfExclusionFilled;